import { serializable, alias, primitive } from 'serializr';

export class User {
  @serializable
  id?: string;

  @serializable
  email?: string;

  @serializable
  password?: string;
}
